import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import themeable from 'zignal-landscape/lib/themeable';
import noop from 'lodash/noop';
import * as actions from '../BotIntelligence/BotIntelligence.ducks';
import AddToGroupModal from '../BotIntelligence/containers/AddToGroupModal';

export const mapStateToProps = (
  // eslint-disable-next-line no-unused-vars
  (_state) => ({})
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

export class Groups extends Component {

  componentDidMount() {
    const {
      groupFieldsDestination,
      setAddToGroupModalVisibility,
      setGroupDestinationFields,
      onSuccess,
      onError
    } = this.props;

    setAddToGroupModalVisibility(true);
    setGroupDestinationFields(groupFieldsDestination, onSuccess, onError);
  }

  render() {
    const {
      campaigns,
      defaultCampaign,
      saveToGroup,
      setAddToGroupModalVisibility
    } = this.props;

    return (<AddToGroupModal
      groupFieldsDestination={this.props.groupFieldsDestination}
      campaigns={campaigns}
      defaultCampaign={defaultCampaign}
      saveToGroup={saveToGroup}
      setAddToGroupModalVisibility={setAddToGroupModalVisibility}
    />);
  }
}

Groups.propTypes = {
  campaigns: PropTypes.array,
  defaultCampaign: PropTypes.object,
  saveToGroup: PropTypes.func,
  setAddToGroupModalVisibility: PropTypes.func,
  setGroupDestinationFields: PropTypes.func,
  groupFieldsDestination: PropTypes.array,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

Groups.defaultProps = {
  onSuccess: noop,
  onError: noop,
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(Groups));
